export const FLG_CLOSE = '已處理';
export const FLG_OPEN = '待處理';
export const FLG_SEND = '已寄送';
export const CASE_PRIORITY_HIGH = '緊急';
export const CASE_PRIORITY_NORMAL = '一般';
export const CASE_STATUS_OPEN = '未結案';
export const CASE_STATUS_CLOSE = '已結案';
export const TITLE_DEPARTMENT_NEW = '新增部門';
export const TITLE_DEPARTMENT_EDIT = '修改部門';
export const TITLE_CUSTOMER_NEW = '新增客戶';
export const TITLE_MACHINE_NEW = '新增機器';
export const TITLE_MACHINE_EDIT = '修改機器';
export const TITLE_CUSTOMER_EDIT = '修改客戶';
export const TITLE_EMPLOYEE_NEW = '新增員工';
export const TITLE_EMPLOYEE_EDIT = '修改員工';
export const TITLE_POSITION_NEW = '新增職位';
export const TITLE_POSITION_EDIT = '修改職位';
export const TITLE_CONDITION_NEW = '新增指派條件';
export const TITLE_CONDITION_EDIT = '修改指派條件';
export const LIMIT_PER_PAGE = 20;
